import {
  Folder,
  Scale,
  BarChart3,
  FileCheck,
  FileSignature,
  Award,
  UserSquare2,
  Receipt,
  MoreHorizontal,
} from 'lucide-react'
import { cn } from '@/lib/utils'
import { formatFileSize } from '@/types/documentos'

// Mapeo de categorías a iconos
const CATEGORIA_ICONS: Record<string, React.ElementType> = {
  poderes: Scale,
  balances: BarChart3,
  ddjj: FileCheck,
  contratos: FileSignature,
  constancias: Award,
  identificacion: UserSquare2,
  comprobantes: Receipt,
  otros: MoreHorizontal,
}

interface CarpetaItemProps {
  categoria: string
  label: string
  color: string
  cantidadDocs: number
  tamanoTotal: number
  isSelected: boolean
  onClick: () => void
}

export function CarpetaItem({
  categoria,
  label,
  cantidadDocs,
  tamanoTotal,
  isSelected,
  onClick,
}: CarpetaItemProps) {
  const isEmpty = cantidadDocs === 0
  // Usar icono específico de la categoría o carpeta por defecto
  const CategoryIcon = CATEGORIA_ICONS[categoria] || Folder

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'w-full flex items-start gap-3 p-3 rounded-lg text-left transition-colors',
        isSelected
          ? 'bg-accent/10 border border-accent'
          : 'hover:bg-muted border border-transparent',
        isEmpty && 'opacity-50'
      )}
    >
      <CategoryIcon
        className={cn(
          'h-5 w-5 mt-0.5 shrink-0',
          isSelected ? 'text-accent' : isEmpty ? 'text-muted-foreground' : 'text-accent'
        )}
      />
      <div className="flex-1 min-w-0">
        <p className={cn(
          'font-medium truncate',
          isEmpty && 'text-muted-foreground'
        )}>
          {label}
        </p>
        <p className="text-xs text-muted-foreground">
          {cantidadDocs} {cantidadDocs === 1 ? 'documento' : 'documentos'}
          {cantidadDocs > 0 && (
            <span className="ml-1">· {formatFileSize(tamanoTotal)}</span>
          )}
        </p>
      </div>
    </button>
  )
}
